import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../reducers';

export const IsFormSaved = createSelector(
  getSharedFeatureState,
  state => state.formState.isSaved
);

export const GetFormAlert = createSelector(
  getSharedFeatureState,
  state => state.formState.alert
);
